import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../mockData';

const HeroSection = () => {
  return (
    <section
      className="relative bg-brand-alabaster overflow-hidden pt-28 md:pt-32"
      aria-labelledby="hero-heading"
      data-testid="hero-section"
    >
      {/* Editorial rule at top */}
      <div className="container-editorial">
        <div className="border-t border-brand-hairline" />
      </div>

      <div className="container-editorial pt-14 md:pt-20 pb-20 md:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          {/* Left: type-led hero */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-8">
              <span className="hairline" aria-hidden />
              <span className="eyebrow" data-testid="hero-eyebrow">
                Global Holding Company · Est. {companyInfo.founded}
              </span>
            </div>

            <h1
              id="hero-heading"
              className="font-display text-[44px] leading-[1.02] md:text-[68px] lg:text-[84px] tracking-[-0.02em] text-brand-oxford"
              data-testid="hero-heading"
            >
              A single standard <br className="hidden md:block" />
              for four <span className="italic text-brand-gold">disciplined</span> businesses.
            </h1>

            <p className="mt-8 text-lg md:text-xl text-brand-slate max-w-2xl leading-relaxed" data-testid="hero-subhead">
              Lockene operates across enterprise AI software, government compliance, sports &amp; hospitality
              and premium real estate — advised by senior operators, judged by measurable outcomes.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link
                to="/contact"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-3 bg-brand-oxford text-brand-alabaster px-7 py-4 text-[12px] font-semibold tracking-[0.16em] uppercase transition-colors hover:bg-brand-gold hover:text-brand-oxford focus-ring"
              >
                Start a Conversation
                <span aria-hidden>→</span>
              </Link>
              <Link
                to="/about"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-3 text-brand-oxford border border-brand-oxford px-7 py-4 text-[12px] font-semibold tracking-[0.16em] uppercase transition-colors hover:bg-brand-oxford hover:text-brand-alabaster focus-ring"
              >
                Read Our Story
              </Link>
            </div>
          </div>

          {/* Right: editorial image + metric strip */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -top-3 -left-3 w-24 h-24 border border-brand-oxford/20 pointer-events-none" aria-hidden />
              <div className="relative overflow-hidden bg-white border border-brand-hairline">
                <img
                  src="/images/generated/hero-homepage.jpg"
                  alt="A minimalist alabaster monolith representing Lockene's disciplined corporate structure"
                  className="w-full h-[380px] md:h-[460px] object-cover"
                  loading="eager"
                  data-testid="hero-image"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border border-brand-gold pointer-events-none" aria-hidden />
            </div>
          </div>
        </div>

        {/* Metric strip */}
        <div
          className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 border-t border-brand-hairline"
          data-testid="hero-metrics"
        >
          {companyInfo.metrics.map((m, idx) => (
            <div
              key={m.label}
              className={`py-8 pr-6 ${idx !== 0 ? 'md:border-l md:border-brand-hairline md:pl-8' : ''}`}
            >
              <div className="font-display text-5xl md:text-6xl text-brand-oxford leading-none">
                {m.value}
              </div>
              <div className="mt-3 eyebrow">{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
